import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import { State } from "vuex-class";
import { piThThisTimes } from "@/utils/time.helper";
import { getMerchantInfo, getOperBacklog } from "@/api/api-operation-service";
import i18n from "@/config/i18n";
import { piAhOut } from "@/utils/ajaxdata.helper";
let PiHeader = class PiHeader extends Vue {
    constructor() {
        super(...arguments);
        this.time = "";
        this.navIndex = 1;
        this.merchentInfo = {
            fullName: "",
        };
        this.msgNum = 0;
        this.visible = false;
        this.msgTipsList = [
            {
                key: "mchDivideSettlementAmount",
                name: i18n.t("header.order"),
                url: "/revenue-settlement/share-settlement?orderStatus=1",
            },
        ];
    }
    goOut() {
        this.$Modal.confirm({
            title: i18n.t("tips") + "",
            content: i18n.t("header.outConfirm") + "",
            onOk: () => {
                this.sysLoginOut();
                // this.$Message.info("Clicked ok");
            },
            onCancel: () => {
                // this.$Message.info("Clicked cancel");
            },
        });
    }
    async sysLoginOut() {
        piAhOut();
    }
    privilegeVoList(privilegeVoList) {
        let isUrl = false;
        privilegeVoList.map((child) => {
            if (child.privilegeCode == "100501" && child.checked) {
                isUrl = true;
            }
        });
        return isUrl;
    }
    navClick(item) {
        if (item.children && item.children.length > 0) {
            let url = "";
            item.children.map((itemData) => {
                if (itemData.children && item.children.length > 0 && url == "") {
                    itemData.children.map((itemDataChild) => {
                        const list = itemDataChild.privilegeVoList || [];
                        if (this.privilegeVoList(list) && url == "") {
                            url = itemDataChild.url;
                        }
                    });
                }
                else if (url == "") {
                    const list = itemData.privilegeVoList || [];
                    if (this.privilegeVoList(list)) {
                        url = itemData.url;
                    }
                }
            });
            if (this["$route"].path != url) {
                this.$router.push(url);
            }
        }
        else {
            this.$router.push(item.url);
        }
    }
    goHome() {
        const url = this["$route"].path;
        if (url != "/home") {
            this.$router.push("/home");
        }
    }
    async getMerchantInfo() {
        const ret = await getMerchantInfo({
            merchantPkId: this.sys.userInfo.merchantPkId,
        });
        if (ret.status == this["$config"].apiStatus) {
            const data = ret.data[0];
            this.merchentInfo.fullName = data.fullName;
            document.title = "【" + data.fullName + "】" + i18n.t("sysTitle");
        }
    }
    async getOperBacklog() {
        const ret = await getOperBacklog({});
        if (ret.status === this.$config.apiStatus) {
            const data = ret.data[0];
            this.msgNum = data.totalAmount || 0;
            for (const i in data) {
                this.msgTipsList.map((item) => {
                    if (i == item.key) {
                        item.value = data[i];
                    }
                });
            }
        }
    }
    mounted() {
        if (this.isLogin) {
            this.getOperBacklog();
        }
        this.time = piThThisTimes("yyyy-MM-dd HH:MM");
        console.log(this.time);
        this.getMerchantInfo();
    }
};
__decorate([
    Prop({ default: "" })
], PiHeader.prototype, "menuId", void 0);
__decorate([
    Prop({ default: false })
], PiHeader.prototype, "isLogin", void 0);
__decorate([
    State("sys")
], PiHeader.prototype, "sys", void 0);
PiHeader = __decorate([
    Component
], PiHeader);
export default PiHeader;
